var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <div class=\"text-center popup-message\"> <div class=\"alert alert-success\" ng-show=\"$ctrl.show && $ctrl.errors.length === 0\" ng-bind=\"$ctrl.message\"> </div> <div class=\"alert alert-danger\" ng-show=\"$ctrl.show && $ctrl.errors.length > 0\"> <p ng-repeat=\"error in $ctrl.errors track by $index\"> {{ error.Message | i18next:error.Params }} </p> </div> </div> </web-component>";
var id1="popupMessage.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/popupMessage/popupMessage.html
// module id = 503
// module chunks = 2